import { Helpers } from '../../helpers';
import { IFracGroupSisterPad } from '../../interfaces/ifrac-group-sister-pad';
import { GroupRelationship } from '../group-relationship';
import { Scenario } from '../scenario';

export class FracGroupSisterPadBase {
  FracGroupSisterPadId: number;
  ScenarioId: number;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  GroupRelationships_FracGroupSisterPad?: Array<GroupRelationship> | null;
  Scenario?: Scenario;

  constructor(item?: IFracGroupSisterPad) {
    if (item) {

      this.FracGroupSisterPadId = item.FracGroupSisterPadId;
      this.ScenarioId = item.ScenarioId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.GroupRelationships_FracGroupSisterPad = Helpers.createClassArray(GroupRelationship, item.GroupRelationships_FracGroupSisterPad);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}